import List from './ScheduleList'
import LectureDetails from './LectureDetails'

const exportObj = {
    List,
    LectureDetails
}

export default exportObj